import { Controller } from "@hotwired/stimulus";
import { DEVICE_TYPE_DEFAULTS } from "../devices/typeDefaults";

// Pre-fills the device form when Primary Device Type changes on a fresh
// (devices/new) form. No-ops on edit forms — Reset to defaults is the
// explicit override path there.
export default class extends Controller {
  static targets = [
    "primarySelect",
    "portsContainer",
    "portsTemplate",
    "audioEffectCheckbox",
  ];
  static values = { fresh: Boolean };

  apply() {
    if (!this.freshValue) return;
    if (!this.hasPrimarySelectTarget) return;

    const option = this.primarySelectTarget.selectedOptions[0];
    if (!option || !option.value) return;
    const typeName = option.text.trim();
    const defaults = DEVICE_TYPE_DEFAULTS[typeName];
    if (!defaults) return;

    if (defaults.power) this.applyPower(defaults.power);
    if (defaults.ports) defaults.ports.forEach((attrs, i) => this.addPort(attrs, i));
    if (defaults.openAudioEffect) this.openAudioEffect();
  }

  applyPower(power) {
    Object.entries(power).forEach(([key, value]) => {
      const input = this.element.querySelector(`[name="device[power_${key}]"]`);
      if (input) input.value = value;
    });
  }

  addPort(attrs, index) {
    if (!this.hasPortsContainerTarget || !this.hasPortsTemplateTarget) return;
    const uniqueId = `${Date.now()}-${index}-${Math.random().toString(36).slice(2, 6)}`;
    const html = this.portsTemplateTarget.innerHTML.replace(/NEW_RECORD/g, uniqueId);
    this.portsContainerTarget.insertAdjacentHTML("beforeend", html);
    const row = this.portsContainerTarget.lastElementChild;

    Object.entries(attrs).forEach(([key, value]) => {
      const field = row.querySelector(`[name*="[${key}]"]`);
      if (!field) return;
      if (field.type === "checkbox") {
        field.checked = Boolean(value);
      } else {
        field.value = value;
      }
      field.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  openAudioEffect() {
    if (!this.hasAudioEffectCheckboxTarget) return;
    const cb = this.audioEffectCheckboxTarget;
    if (cb.checked) return;
    cb.checked = true;
    cb.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
